import React from "react";

import { assertThat } from "lib/assert";

import { getStaticSetSubjects } from "lib/parameters";
import { IRulesProps } from "../common/types";
import { SubjectTable } from "../common/subjectTable";
export const StaticSubjectSet = (props: IRulesProps) => {
  const { rule } = props;
  assertThat(rule.children.length === 0, "Subject sets should not have children");

  const subjectRecordIds = getStaticSetSubjects(rule) || [];

  return <SubjectTable subjectRecordIds={subjectRecordIds} />;
};
